//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    FIRMWARE_REQUESTS_DETAILS_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    firmwareRequestDetailsResult,
} from 'Redux/actions';

function* getGadgetData({ payload }) {
    try {
        let QUERY = `
            query getGadgetData ($id: String!, $query: GadgetDataQuery) {
                result: getGadgetData (id: $id, query: $query)
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            payload.data,
            endpoints.GRAPHQL_GENERAL,
        );
        
        if(data?.result){
            yield put(firmwareRequestDetailsResult(data?.result))
        } else yield put(firmwareRequestDetailsResult(null))
        
    } catch (exc) {
        yield put(firmwareRequestDetailsResult(null))
        ExceptionManager(exc, 'Modules/dashboard/views/.components/dashboardPanel/.components/firmwareDetails/redux/saga', 'getGadgetData');
    }
}

function* watchDashboardPanelRequests() {
    yield takeEvery(FIRMWARE_REQUESTS_DETAILS_REQUEST, getGadgetData);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchDashboardPanelRequests)
    ]);
}